<template>
  <textarea style="text-align: left; direction: ltr !important;" v-model="recipient" class="full_width">
  </textarea>
</template>
<script>
import PositionsHelper from '@/custom/classes/positions_helper.js'
export default {
  name: 'position-email-text-area',
  props: ['position', 'value'],
  data () {
    return {
      positions_helper: new PositionsHelper(),
      recipient: ''
    }
  },
  watch: {
    value () {
      this.recipient = this.value
    },
    recipient () {
      this.$emit('input', this.recipient.replace(/\s/g, ''))
    }
  },
  created () {
    this.positions_helper.getCVRecipient(this.position).then(response => {
      this.recipient = response
    })
  }
}
</script>
